import { creatorbase } from '@round/api';

type PlatformDetails<TPlatform extends creatorbase.Platform> =
    | (TPlatform extends 'tiktok'
          ? creatorbase.TiktokPostDetails
          : TPlatform extends 'instagram'
            ? creatorbase.InstagramPostDetails
            : creatorbase.YoutubePostDetails)
    | null;

export const getPostPlatformDetails = <TPlatform extends creatorbase.Platform>(
    post: creatorbase.Post,
    platform: TPlatform
): PlatformDetails<TPlatform> => {
    if (platform === 'tiktok') {
        return post.tiktok_details as PlatformDetails<TPlatform>;
    }

    if (platform === 'instagram') {
        return post.instagram_details as PlatformDetails<TPlatform>;
    }

    if (platform === 'youtube') {
        return post.youtube_details as PlatformDetails<TPlatform>;
    }

    return null;
};
